var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3733 0.660266L6.0001 4.92326L1.62685 0.660266C1.54871 0.583946 1.44382 0.541219 1.3346 0.541219C1.22537 0.541219 1.12048 0.583946 1.04235 0.660266C1.00451 0.697334 0.974458 0.741579 0.953939 0.79041C0.93342 0.83924 0.922852 0.891674 0.922852 0.94464C0.922852 0.997607 0.93342 1.05004 0.953939 1.09887C0.974458 1.1477 1.00451 1.19195 1.04235 1.22902L5.69472 5.76502C5.77642 5.84465 5.886 5.88922 6.0001 5.88922C6.11419 5.88922 6.22377 5.84465 6.30547 5.76502L10.9578 1.22989C10.9959 1.19279 11.0262 1.14844 11.0469 1.09945C11.0676 1.05046 11.0782 0.997818 11.0782 0.94464C11.0782 0.891463 11.0676 0.838825 11.0469 0.789833C11.0262 0.74084 10.9959 0.696487 10.9578 0.65939C10.8797 0.583071 10.7748 0.540344 10.6656 0.540344C10.5564 0.540344 10.4515 0.583071 10.3733 0.65939V0.660266Z",
    fill: "#1D3440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.c481858f3b2ad53c70eea1a776115ac3.svg";
export { ForwardRef as ReactComponent };